import { ApcmOpsPage as ApcmOpsFeature } from "@/features/apcm-ops"

export default function ApcmOpsPage() {
  return <ApcmOpsFeature />
}
